import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
  `}
`;

export const HeadWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin: 48px 0;
`;

export const IconCircle = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 50%;
    height: 32px;
    width: 32px;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    margin: 8px 0;
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  margin: 40px auto 0 auto;
  gap: 16px;
`;
